import React from "react";
import { Form, Input, Select, Rate, InputNumber, Switch } from "antd";
import { IconStar } from "@tabler/icons-react";

export default function BasicSection({ issuerOptions, categoryOptions }) {
  return (
    <>
      <Form.Item
        name="issuerId"
        label="Байгууллага"
        rules={[{ required: true, message: "Байгууллага сонгоно уу" }]}
      >
        <Select
          allowClear
          placeholder="Банк / ББСБ сонгох"
          showSearch
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          options={issuerOptions}
        />
      </Form.Item>

      <Form.Item
        name="type"
        label="Зээлийн төрөл"
        rules={[{ required: true, message: "Төрөл сонгоно уу" }]}
      >
        <Select
          allowClear
          placeholder="Сонгох"
          options={[
            { value: "BANK", label: "Банкны зээл" },
            { value: "NBFI", label: "ББСБ-ын зээл" },
          ]}
        />
      </Form.Item>

      <Form.Item
        name="name"
        label="Зээлийн нэр"
        rules={[{ required: true, message: "Нэр оруулна уу" }]}
      >
        <Input placeholder="Жишээ: Өрхийн зээл" />
      </Form.Item>

      <Form.Item
        label="Тайлбар нэршил"
        name="highlight"
        rules={[{ required: true, message: "Тайлбар нэршил өгнө үү" }]}
      >
        <Input placeholder="2–3 үг (жишээ: Хурдан, хялбар)" />
      </Form.Item>

      <Form.Item
        name="categoryId"
        label="Ангилал"
        rules={[{ required: true, message: "Ангилал сонгоно уу" }]}
      >
        <Select
          allowClear
          placeholder="Ангилал сонгох"
          options={categoryOptions}
        />
      </Form.Item>

      <Form.Item
        label="Үнэлгээ (rating)"
        name="rating"
        rules={[{ required: true, message: "Үнэлгээ өгнө үү" }]}
      >
        <InputNumber
          prefix={<IconStar size={16} color="#e68200ff" />}
          min={0}
          max={5}
          step={0.1}
          placeholder="4.5"
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item name="applyUrl" label="Захиалах холбоос">
        <Input placeholder="https://..." />
      </Form.Item>
      <Form.Item
        name="featured"
        label="Нүүрэнд онцлох"
        valuePropName="checked"
        tooltip="Нүүр хуудасны 'Жишээ бүтээгдэхүүн' хэсэгт харагдана"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
    </>
  );
}
